import _ from 'lodash';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';
import async from 'async';
import moment from "moment";
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
// import Grid from '@material-ui/core/Grid';

import OpenLink from '@material-ui/icons/OpenInNew';

// local
import InventoryAllocationsContainer from '../../containers/inventory/InventoryAllocations';
import {post} from "../../modules/utility";
import { showErrors } from '../../modules/general';
import FMPRegionHeader from "../../components/ui/FMPRegionHeader";
import EnhancedTable from "../../components/table/EnhancedTable";
import Grid from "@material-ui/core/Grid";

import {valueToDisplay} from "../../libs/products";
import FMPSectionHeader from "../../components/ui/FMPSectionHeader";
import {getSharedStyles} from "../../themes";
import Button from "@material-ui/core/Button";
import FMPAddButton from "../../components/ui/FMPAddButton";
import {
	Area,
	CartesianGrid,
	Cell,
	ComposedChart,
	Legend,
	Line,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
	PieChart,
	Pie,
} from "recharts";
import MuiTooltip from "@material-ui/core/Tooltip";
import SaveFuelMaintenanceCostDialog from "../../components/Dialogs/SaveFuelMaintenanceCostDialog";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import {Link} from "react-router-dom";
const reasonToDisplay = {
	activeContract : 'Active Contract',
	previousMonthRollOver : 'Previous Rollover',
	interTankTransfer : 'Tank Transfer',
	other : 'Other',
};

const RTC_FUELS_BULK_CUSTOMER_ID = 10;

const formatCpg = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 5,
}).format;

const fifoColors = [
	`rgba(131, 166, 237, .9)`,
	`rgba(141, 209, 225, .9)`,
	`rgba(130, 202, 157, .9)`,
	`rgba(164, 222, 108, .9)`,
	`rgba(208, 237, 87, .9)`,
	`rgba(255,245,157, .9)`,
	`rgba(255,204,128, .9)`,
	`rgba(255,171,145, .9)`,
	`rgba(244,143,177, .9)`,
	`rgba(206,147,216, .9)`,
	`rgba(179,157,219, .9)`,
];

const fifoDarkColors = [
	`rgba(101, 136, 207, 1)`,
	`rgba(111, 179, 195, 1)`,
	`rgba(100, 172, 127, 1)`,
	`rgba(134, 192, 78, 1)`,
	`rgba(178, 207, 57, 1)`,
	`rgba(215, 205, 107, 1)`,
	`rgba(225, 174, 98, 1)`,
	`rgba(225, 141, 115, 1)`,
	`rgba(214, 113, 177, 1)`,
	`rgba(176, 117, 186, 1)`,
	`rgba(149, 127, 189, 1)`,
];


const styles = (theme) => {
	return {
		...getSharedStyles(theme),
		linkedItem : {
			fontSize: 14,
			textDecoration: 'none',
			display : 'flex',
			alignItems : 'center',
		},
		openLink : {
			paddingLeft : 4,
			width : 14,
			height : 14,
		},
		diffError : {
			fontWeight : 900,
			color : '#FF500F',
		},
		contractSub : {
			paddingLeft: 10,
			fontSize: 14,
			color: "#666",
		},
		todo : {
			border : `1px solid #bbb`,
			color : '#666',
			padding : 5,
			fontStyle : 'italic',
		},
		addButton : {
			verticalAlign : 'middle',
			textDecoration: 'none',
			marginBottom: 10,
			borderRadius: 100
		},
		divider : {
			color :'#aaa',
			paddingLeft:7,
			paddingRight:7,
		}
	};
};

const deliveryInvoiceColumns = [{
	sortId: 'type',
	displayId : 'typeAndProduct',
	labels : ['Type / Carrier', 'Product'],
}, {
	sortId: 'deliveryDateSort',
	displayId : 'deliveryDisplay',
	label: 'Delivery Info'
}, {
	sortId: 'invoiceId',
	displayId : 'invoiceDisplay',
	label : 'Invoice Info',
}, {
	sortId: 'totalDeliveryAmount',
	displayId : 'deliveryVolumes',
	label: 'Scheduled Volumes',
}, {
	sortId: 'productType',
	displayId : 'invoiceVolumes',
	label: 'Invoiced (net) Volumes',
}, {
	sortId: 'totalDiff',
	displayId : 'diffDisplay',
	label: 'Diff',
}, {
	sortId: 'finalCostPerGallon',
	displayId : 'costDisplay',
	label: 'Costs',
}];

const additionalFuelAllocationColumns = [{
	sortId: 'productTypeDisplay',
	displayId : 'productTypeDisplay',
	label : 'Product',
}, {
	sortId: 'numberOfGallons',
	displayId : 'numberOfGallonsDisplay',
	label : 'Gallons',
}, {
	sortId: 'fuelContractDisplay',
	displayId : 'fuelContractDisplay',
	label : 'Fuel Contract',
}, {
	sortId: 'allocationReasonDisplay',
	displayId : 'allocationReasonDisplay',
	labels : ['Allocation Reason', 'Note'],
}, {
	sortId: 'allocationDate',
	displayId : 'allocationDateFormatted',
	label : 'Allocation Date',
}, {
	sortId: 'dateCreated',
	displayId : 'dateCreatedFormatted',
	label : 'Date Added',
}, {
	sortId: 'createdByUserDisplay',
	displayId : 'createdByUserDisplay',
	label : 'Added By',
}, {
	sortId: 'edit',
	displayId : 'editButtons',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];

const fuelMaintenanceCostColumns = [{
	sortId: 'fuelDisplay',
	displayId : 'fuelDisplay',
	label : 'Product',
}, {
	sortId: 'cost',
	displayId : 'costDisplay',
	label : 'Cost Amount',
}, {
	sortId: 'description',
	displayId : 'description',
	label : 'Description',
}, {
	sortId: 'dateCreated',
	displayId : 'dateCreatedFormatted',
	label : 'Date Added',
}, {
	sortId: 'createdByUserDisplay',
	displayId : 'createdByUserDisplay',
	label : 'Added By',
}, {
	sortId: 'edit',
	displayId : 'editButtons',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];

class InventoryAllocationDetails extends Component {
	constructor(props) {
		super(props);

		const inventoryAllocationId = _.get(this.props, ['match', 'params', 'inventoryAllocationId']);
		let yearMonth = _.get(this.props, ['match', 'params', 'yearMonth']);
		this.state = {
			inventoryAllocationId,
			yearMonth,
			isFetching : true,
			isSaveFuelMaintenanceCostDialogOpen : false,
			fuelMaintenanceCostToUpdate : undefined,
		};
	}

	componentDidMount() {
		this.getInventoryAllocation();
	}

	componentDidUpdate(prevProps, prevState) {
		const { inventoryAllocationsByYearMonth } = this.props;
		const {yearMonth} = this.state;

		//- THis has to also check for the state to be updated based on the container
		if (prevState.yearMonth !== yearMonth) {
			this.setState({ inventoryAllocations : undefined });
			this.getInventoryAllocation();
		}

		if (
			_.isUndefined(prevProps.inventoryAllocationsByYearMonth[yearMonth])
			&& inventoryAllocationsByYearMonth[yearMonth]
		) {
			this.formatInventoryAllocation({ inventoryAllocations : inventoryAllocationsByYearMonth[yearMonth] });
		}
	}

	getInventoryAllocation = () => {
		const { inventoryAllocationsByYearMonth, inventoryAllocationSearch} = this.props;
		const { yearMonth } = this.state;

		// See if we need to fetch or not
		if (!inventoryAllocationsByYearMonth || !inventoryAllocationsByYearMonth[yearMonth]) {
			this.setState({isFetching: true});
			const yearMonthMoment = (yearMonth) ? moment(yearMonth, 'YYYY-MM') : moment();
			inventoryAllocationSearch({
				month: yearMonthMoment.month(),
				year: yearMonthMoment.year(),
			});
		} else {
			this.formatInventoryAllocation({ inventoryAllocations : inventoryAllocationsByYearMonth[yearMonth] });
		}
	}

	formatInventoryAllocation = ({ inventoryAllocations }) => {
		const { inventoryAllocationId } = this.state;

		let selectedInventoryAllocation = undefined;
		inventoryAllocations.forEach(inventoryAllocation => {
			// const {} = inventoryAllocation;
			if (inventoryAllocationId === inventoryAllocation.inventoryAllocationId) {
				selectedInventoryAllocation = inventoryAllocation;
			}

		});

		if (!selectedInventoryAllocation) { return; }

		const {supplierMap, terminalMap} = this.props;

		//- Format the selected
		const {
			// inventoryAllocationId,
			// productType,
			allocatedForTerminalId,
			supplierForTerminalId,
			// contractLoadingNumber,
			// totalAllocation,
			// totalByDelivery,
			// totalByInvoice,
			// totalByDeliveryThatAlsoHasInvoice,
			// allocationSources,
			// additionalFuelAllocationIds,
		} = selectedInventoryAllocation;

		selectedInventoryAllocation.supplier = supplierMap[supplierForTerminalId] || {name: 'Missing'};
		selectedInventoryAllocation.terminal = terminalMap[allocatedForTerminalId] || {name: 'Missing'};

		this.setState({
			inventoryAllocation : selectedInventoryAllocation,
			isFetching: false,
			isFetchingDeliveries : true
		});

		const { stationDeliveryIds, bulkDeliveryIds, productType, deliveryIdToCosts } = selectedInventoryAllocation;
		async.parallel({
			stationDeliveryResult : callback => {
				post({
					method: 'stationDelivery.get',
					params: {
						stationDeliveryIds,
					},
					callback
				});
			},
			bulkDeliveryResult: callback => {
				post({
					method: 'bulkDelivery.get',
					params: {
						bulkDeliveryIds,
					},
					callback
				});
			},
			stationInvoiceResult: callback => {
				post({
					method: 'stationInvoice.search',
					params: {
						linkedStationDeliveryIds : stationDeliveryIds,
					},
					callback
				});
			},
			bulkInvoiceResult: callback => {
				post({
					method: 'bulkInvoice.search',
					params: {
						linkedBulkDeliveryIds : bulkDeliveryIds,
					},
					callback
				});
			},
		}, (err, r) => {
			if (err) {
				this.setState({isSavingOpen: false});
				return showErrors((_.isArray(err)) ? err : [err]);
			}
			const stationDeliveryResult = r.stationDeliveryResult;
			const bulkDeliveryResult = r.bulkDeliveryResult;
			const stationInvoiceResult = r.stationInvoiceResult;
			const bulkInvoiceResult = r.bulkInvoiceResult;

			const sdc = stationDeliveryResult.collections;
			const sic = stationInvoiceResult.collections;
			const stationDeliveries = _.get(sdc, 'stationDeliveryCollection', []);
			const stationLookup = _.keyBy(_.get(sdc, 'stationCollection', []), 'stationId');
			let carrierLookup = _.keyBy(_.get(sdc, 'carrierCollection', []), 'carrierId');
			let terminalLookup = _.keyBy(_.get(sic, 'terminalCollection', []), 'terminalId');

			const stationInvoicesByDeliveryId = _.groupBy(
				_.get(sic, 'stationInvoiceCollection', []), 'linkedStationDeliveryId'
			);
			const deliveryInvoiceRows = [];
			stationDeliveries.forEach(stationDelivery => {
				addStationDeliveryInvoiceRow({
					deliveryInvoiceRows, stationDelivery,
					stationLookup, terminalLookup, carrierLookup,
					stationInvoicesByDeliveryId,
					classes : this.props.classes,
					allocationProductType : productType,
					deliveryIdToCosts,
				});
			});

			const bdc = bulkDeliveryResult.collections;
			const bic = bulkInvoiceResult.collections;

			const bulkDeliveries = _.get(bdc, 'bulkDeliveryCollection', []);
			const bulkCustomerLookup = _.keyBy(_.get(bdc, 'bulkCustomerCollection', []), 'bulkCustomerId');
			carrierLookup = _.keyBy(_.get(bdc, 'carrierCollection', []), 'carrierId');
			terminalLookup = _.keyBy(_.get(bdc, 'terminalCollection', []), 'terminalId');
			const supplierLookup = _.keyBy(_.get(bdc, 'supplierCollection', []), 'supplierId');

			const bulkInvoicesByDeliveryId = _.groupBy(_.get(bic, 'bulkInvoiceCollection', []), 'linkedBulkDeliveryId');
			bulkDeliveries.forEach(bulkDelivery => {
				addBulkDeliveryInvoiceRow({
					deliveryInvoiceRows, bulkDelivery,
					bulkCustomerLookup, terminalLookup, carrierLookup, supplierLookup,
					bulkInvoicesByDeliveryId,
					classes : this.props.classes,
					allocationProductType : productType,
					deliveryIdToCosts,
				});
			});
			this.setState({ deliveryInvoiceRows, isFetchingDeliveries: false });
		});
	}

	handleAdditionalFuelAllocationEdit = (handleAdditionalFuelAllocationId) => {
		this.props.history.push(
			`/inventoryManagement/additionalFuelAllocation/update/${handleAdditionalFuelAllocationId}`
		);
	};

	handleFuelMaintenanceCostEdit = (fuelMaintenanceCost) => {
		this.setState({
			isSaveFuelMaintenanceCostDialogOpen : true,
			fuelMaintenanceCostToUpdate : fuelMaintenanceCost
		});
	};

	handleCloseSaveFuelMaintenanceCostDialog = () => {
		this.setState({
			isSaveFuelMaintenanceCostDialogOpen : false,
			fuelMaintenanceCostToUpdate : undefined
		});
	};

	render () {
		const {classes} = this.props;
		const { inventoryAllocation, deliveryInvoiceRows } = this.state;
		if (!inventoryAllocation) {
			return (<div>Loading...</div>);
		}

		const { fuelContractMap,  additionalFuelAllocationMap, fuelMaintenanceCostMap, userMap } = this.props;

		const {
			inventoryAllocationId,
			productType,
			terminal,
			supplier,
			contractLoadingNumber,
			totalAllocation,
			totalByDelivery,
			totalByInvoice,
			totalByDeliveryThatAlsoHasInvoice,
			allocationSources,
			additionalFuelAllocationIds,
			fuelMaintenanceCostIds = [],
			fuelBlendedCost,
			totalFuelMaintenanceCost,
			fuelMaintenanceCostPerGallon,
			totalDeliveriesNotYetInvoiced,
			finalCost,
		} = inventoryAllocation;
		const fuelDisplay = valueToDisplay(productType);

		const allocationSourcesByReason = _.groupBy(allocationSources, 'allocationReason');
		/** @namespace allocationSourcesByReason.activeContract **/
		const activeContracts = _.sortBy(allocationSourcesByReason.activeContract, 'allocationAmount');
		let activeContract;
		if (!_.isEmpty(activeContracts)) {
			activeContract = _.first(activeContracts);
			inventoryAllocation.activeContractsDisplay = activeContracts.map(allocationSource => {
				const {fuelContractId} = allocationSource;

				const fuelContract = fuelContractMap[fuelContractId] || {sourceCustomer: 'Missing'};
				const {sourceCustomer, contractNumber} = fuelContract;

				return (
					<div key={`${inventoryAllocationId}_${fuelContractId}`}>
						<div>Source : {sourceCustomer}</div>
						<div className={classes.contractNumber}>Contract : {contractNumber}</div>
					</div>
				);
			});
		}

		const remaining = totalAllocation - totalByDelivery;

		inventoryAllocation.totalAllocationDisplay = (<div>
			<div>Total : {totalAllocation.toLocaleString()}</div>
			<div>All Deliveries : {totalByDelivery.toLocaleString()}</div>
			<div><strong>Remaining : {remaining.toLocaleString()}</strong></div>
		</div>);

		inventoryAllocation.allocationSourcesDisplay = _.values(allocationSourcesByReason).map(allocationSources => {
			let reasonDisplay = '';
			let total = 0;
			allocationSources.forEach(allocationSource => {
				const {allocationReason, allocationAmount} = allocationSource;
				total += allocationAmount;
				reasonDisplay = reasonToDisplay[allocationReason] || 'Missing';
			});

			return (<div key={reasonDisplay}>
				<div>{reasonDisplay} : {total.toLocaleString()}</div>
			</div>);
		});

		inventoryAllocation.deliveryVsInvoiceDiff = totalByInvoice - totalByDeliveryThatAlsoHasInvoice;
		inventoryAllocation.deliveryVsInvoice = (<div>
			<div>Total gallons from deliveries that have been invoiced :
				<span> {totalByDeliveryThatAlsoHasInvoice.toLocaleString()}</span>
			</div>
			<div><strong>Total net gallons invoiced: {totalByInvoice.toLocaleString()}</strong></div>
			<div>Difference : {inventoryAllocation.deliveryVsInvoiceDiff.toLocaleString()}</div>
		</div>);


		const additionalFuelAllocationRows = [];
		additionalFuelAllocationIds.forEach(additionalFuelAllocationId => {
			const additionalFuelAllocation = additionalFuelAllocationMap[additionalFuelAllocationId];
			if (!additionalFuelAllocation) {
				console.error(`Missing additional fuel allocation`, additionalFuelAllocationId);
				return;
			}
			const {
				productType,
				numberOfGallons,
				allocationReason,
				allocationReasonNote,
				allocationDate,
				dateCreated,
				fuelContractId,
				createdByUserId,
				isSystemGenerated,
				linkedRackTransferId,
			} = additionalFuelAllocation;

			//- A system row has no createdByUserId -- the inventory balance recalculator wrote
			//- it, not a person. Without this it rendered as "Missing undefined". Rack transfer
			//- rows are also FMP-written but stay editable (Kat may re-point one).
			const createdByUser = userMap[createdByUserId] || { firstName : 'Missing', lastName : '' };
			const createdByDisplay = isSystemGenerated || linkedRackTransferId
				? 'FMP'
				: `${createdByUser.firstName} ${createdByUser.lastName}`.trim();

			const fuelContract = fuelContractMap[fuelContractId] || {sourceCustomer: 'Missing'};
			const { supplierMap, terminalMap } = this.props;
			const {
				allocatedForTerminalId, supplierForTerminalId,
				sourceCustomer, contractNumber,
				quarter,
			} = fuelContract;
			const supplier = supplierMap[supplierForTerminalId] || { name : 'Missing'};
			const terminal = terminalMap[allocatedForTerminalId] || { name : 'Missing'};
			const fuelDisplay = valueToDisplay(productType);
			const fuelContractDisplay = (
				<div key={fuelContractId}>
					<div>
						<div>{quarter} : {sourceCustomer} ({contractNumber})</div>
						<div className={classes.contractSub}>{fuelDisplay} @ {terminal.name} / {supplier.name}</div>
					</div>
				</div>
			);

			additionalFuelAllocationRows.push({
				key : additionalFuelAllocationId,
				productTypeDisplay : valueToDisplay(productType),
				numberOfGallons,
				numberOfGallonsDisplay : numberOfGallons.toLocaleString(),
				fuelContractDisplay,
				allocationReasonDisplay : (<>
					<div>Reason : {reasonToDisplay[allocationReason]}</div>
					<div>{allocationReasonNote}</div>
					{linkedRackTransferId ? (
						<div>
							<a
								href={`/accounting/rackTransfer/update/${linkedRackTransferId}`}
								className={classes.linkedItem}
								target="_blank"
								rel='noreferrer noopener'
							>
								<span>Rack Transfer #{linkedRackTransferId}</span>
								{' '}<OpenLink className={classes.openLink} />
							</a>
						</div>
					) : null}
				</>),
				allocationReasonNote,
				fuelContractId,
				allocationDate,
				allocationDateFormatted : moment(allocationDate).format('M/D'),
				dateCreated,
				dateCreatedFormatted : moment(dateCreated).format('M/D h:mm a'),
				createdByUserDisplay : createdByDisplay,
				editButtons : isSystemGenerated ? (
					//- Editing a system row is pointless and misleading: the recalculator owns it
					//- and overwrites it on the next recompute, so any change would silently
					//- disappear. A disabled MUI Button fires no mouse events, hence the span --
					//- without it the tooltip never shows.
					<MuiTooltip
						title={
							<span style={{ fontSize : '0.85rem' }}>
								Calculated by the FMP from the prior month&apos;s ending inventory, so it
								cannot be edited by hand — the next recalculation would overwrite your
								change. To move this number, correct the source data (vendor bills,
								invoices or the fuel contract) for that month and it will update here.
							</span>
						}
					>
						<span>
							<Button className={classes.button} disabled>
								Edit
							</Button>
						</span>
					</MuiTooltip>
				) : (
					<Button className={classes.button} onClick={
						() => this.handleAdditionalFuelAllocationEdit(additionalFuelAllocationId)}
					>
						Edit
					</Button>
				),
			});
		});

		const fuelMaintenanceCostRows = [];
		fuelMaintenanceCostIds.forEach(fuelMaintenanceCostId => {
			const fuelMaintenanceCost = fuelMaintenanceCostMap[fuelMaintenanceCostId];
			if (!fuelMaintenanceCost) {
				console.error(`Missing fuelMaintenanceCost`, fuelMaintenanceCostId);
				return;
			}
			const {
				cost,
				description,
				dateCreated,
				createdByUserId
			} = fuelMaintenanceCost;

			const createdByUser = userMap[createdByUserId] || { firstName : 'Missing' };

			fuelMaintenanceCostRows.push({
				key : fuelMaintenanceCostId,
				fuelDisplay,
				cost,
				costDisplay : cost.toLocaleString(),
				description,
				dateCreated,
				dateCreatedFormatted : moment(dateCreated).format('M/D h:mm a'),
				createdByUserDisplay : `${createdByUser.firstName} ${createdByUser.lastName}`,
				editButtons : (
					<Button
						className={classes.button}
						onClick={() => this.handleFuelMaintenanceCostEdit(fuelMaintenanceCost)}
					>
						Edit
					</Button>
				),
			});
		});



		const { yearMonth } = this.state;
		const yearMonthFormatted = moment(yearMonth, 'YYYY-MM').format('MMMM, YYYY');

		return (<Grid container spacing={2}>
			<Grid item xs={12}>
				<div style={{display : 'flex', alignItems : 'flex-end', justifyContent : 'space-between' }}>
					<FMPRegionHeader isTop={true} label={`Inventory Allocation - ${yearMonthFormatted}`} />
				</div>
			</Grid>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						<Grid item xs={12} md={5}>
							<FMPSectionHeader label={'Terminal / Supplier'} isTop={true} />
							<div>
								<span className={classes.label}>Terminal : </span>
								<span className={classes.value}>{terminal.name}</span>
							</div>
							<div>
								<span className={classes.label}>Supplier : </span>
								<span className={classes.value}>{supplier.name}</span>
							</div>
							{contractLoadingNumber &&
							<div>
								<span className={classes.label}>Loading Number : </span>
								<span className={classes.value}>{contractLoadingNumber}</span>
							</div>
							}
							<div>
								<span className={classes.label}>Fuel : </span>
								<span className={classes.value}>{fuelDisplay}</span>
							</div>

							{!!activeContract && <>
								<FMPSectionHeader label={'Active Contract'} />
								{inventoryAllocation.activeContractsDisplay}
							</>}

							<FMPSectionHeader label={'Allocation Sources'} />
							{inventoryAllocation.allocationSourcesDisplay}

							<FMPSectionHeader label={'Allocation Totals'} />
							{inventoryAllocation.totalAllocationDisplay}

							<FMPSectionHeader label={'Invoice / Delivery Comparison'} />
							{inventoryAllocation.deliveryVsInvoice}

							{!!totalDeliveriesNotYetInvoiced &&
								<div style={{marginTop : 20, padding : 10, border:`1px solid #eee`}}>
									<strong>NOTE:</strong>
									There are still {totalDeliveriesNotYetInvoiced} deliveries that have not been invoiced yet.
									Need all deliveries invoiced to properly calculate maintenance cost per gallon invoiced.
								</div>
							}

							<FMPSectionHeader label={'Allocation Costs'} />
							<div>Total Maintenance Cost: {totalFuelMaintenanceCost.toLocaleString()}</div>
							<div>Fuel Maintenance Cost Per Gallon Invoiced : {_.round(fuelMaintenanceCostPerGallon, 5)}</div>
						</Grid>
						<Grid item xs={12} md={7}>
							{this.drawFifo()}
						</Grid>
					</Grid>
				</Paper>

				<ExpansionPanel className={classes.paper} style={{marginTop:15, paddingBottom:10}}>
					<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{padding:0}}>
						<FMPSectionHeader isTop={true} label={
							`Blended Fuel Costs : ${(fuelBlendedCost) ? fuelBlendedCost.toFixed(5) : 'n/a'}`}
						/>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails style={{ display : 'block'}}>
						<Grid container spacing={2}>
							<Grid item xs={12} md={5}>
								<FMPSectionHeader label={'Allocation Costs'} isTop={true}/>
								<div>Blended Fuel Cost :
									{!fuelBlendedCost && <span> n/a</span>}
									{!!fuelBlendedCost && <span> {_.round(fuelBlendedCost, 5)}</span>}
								</div>
								<div>Total Maintenance Cost: {totalFuelMaintenanceCost.toLocaleString()}</div>
								<div>Fuel Maintenance Cost Per Gallon Invoiced : {_.round(fuelMaintenanceCostPerGallon, 5)}</div>

								<div style={{fontWeight:900, fontSize:'120%'}}>Final Fuel Cost :
									{!finalCost && <span> n/a</span>}
									{!!finalCost && <span> {_.round(finalCost, 5)}</span>}
								</div>
							</Grid>
							<Grid item xs={12} md={7}>
								{!fuelBlendedCost && <>
									<div style={{padding : 10, border:`1px solid #eee`}}>
										Can not derive fuel blended cost because we are missing contract pricing.
									</div>
								</>}
								{!!fuelBlendedCost && <>
									<div style={{fontSize : '120%', textAlign : 'center', marginBottom : 2}}>
										Blended Fuel Cost : ${fuelBlendedCost.toFixed(5)}
									</div>
									<div style={{height:600, }}>
										{this.drawCostChart()}
									</div>
								</>}
							</Grid>
						</Grid>
					</ExpansionPanelDetails>
				</ExpansionPanel>
			</Grid>

			<Grid item xs={12}>
				<div style={{display : 'flex', alignItems : 'flex-end', justifyContent : 'space-between' }}>
					<FMPRegionHeader label={'Inventory Tracking and Projections'} />
				</div>
			</Grid>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					<Grid item xs={12}>
						<div className={classes.todo} style={{height : 400}}>
							{this.drawProjectionChart()}
						</div>
					</Grid>
				</Paper>
			</Grid>

			<Grid item xs={12}>
				<div style={{display : 'flex', alignItems : 'flex-end', justifyContent : 'space-between' }}>
					<FMPRegionHeader label={'Additional Fuel Allocations'} />
					<FMPAddButton
						url={'/inventoryManagement/additionalFuelAllocation/add'}
						buttonText={"Add Additional Allocation"}
						canMakeUpdates={this.props.canRwInventoryAllocation}
					/>
				</div>
			</Grid>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					<EnhancedTable
						columns={additionalFuelAllocationColumns}
						rows={additionalFuelAllocationRows}
						defaultOrder={'asc'}
						defaultOrderBy={'allocationDate'}
					/>
				</Paper>
			</Grid>

			<Grid item xs={12}>
				<div style={{display : 'flex', alignItems : 'flex-end', justifyContent : 'space-between' }}>
					<FMPRegionHeader label={'Allocation Maintenance Costs'} />
					<Button
						variant="contained" color="primary" className={classes.addButton}
						onClick={() => {
							this.setState({ isSaveFuelMaintenanceCostDialogOpen : true });
						}}
					>
						Add Fuel Maintenance Cost
					</Button>
				</div>

				<SaveFuelMaintenanceCostDialog
					open={this.state.isSaveFuelMaintenanceCostDialogOpen}
					onClose={this.handleCloseSaveFuelMaintenanceCostDialog}
					fuelMaintenanceCost={this.state.fuelMaintenanceCostToUpdate}
					inventoryAllocationId={inventoryAllocationId}
					yearMonth={yearMonth}
					showErrors={this.props.showErrors}
					history={this.props.history}
				/>

			</Grid>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					<EnhancedTable
						columns={fuelMaintenanceCostColumns}
						rows={fuelMaintenanceCostRows}
						defaultOrder={'asc'}
						defaultOrderBy={'dateCreated'}
					/>
				</Paper>
			</Grid>

			<Grid item xs={12}>
				<FMPRegionHeader label={'Deliveries & Invoices'} />
			</Grid>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					{!_.isEmpty(deliveryInvoiceRows) &&
					<EnhancedTable
						isDense={true}
						columns={deliveryInvoiceColumns}
						rows={deliveryInvoiceRows}
						defaultOrder={'asc'}
						defaultOrderBy={'deliveryDateSort'}
					/>}
				</Paper>
			</Grid>
		</Grid>);
	}

	/*
	drawAllocationCostList = () => {
		const {fuelContractMap} = this.props;
		const {inventoryAllocation} = this.state;
		const {allocationCosts} = inventoryAllocation;

		return (<div>
			{allocationCosts.map(allocationCost => {
				const {key, fuelCost, allocationAmount, fuelContractId} = allocationCost;
				const fuelContract = fuelContractMap[fuelContractId] || {sourceCustomer: 'Missing'};
				const {sourceCustomer, contractNumber} = fuelContract;

				return (<div key={key} style={{padding: 10}}>
					<div>Source Customer : {sourceCustomer}</div>
					<div>Contract: {contractNumber}</div>
					<div>Allocation Amount :{allocationAmount.toLocaleString()}</div>
					{fuelCost &&
						<div>Fuel Cost : {fuelCost || 'n/a'}</div>
					}
					{!fuelCost &&
					<div style={{fontWeight : 900}}>Fuel Cost : not available</div>
					}
				</div>);
			})}
		</div>);
	};
	 */

	drawFifo = () => {
		const { fuelContractMap } = this.props;
		const { inventoryAllocation } = this.state;


		const { fifoAllocationSources, fuelBlendedCost} = inventoryAllocation;

		const len = fifoAllocationSources.length;

		return (<div>

			{!fuelBlendedCost && <>
				<div style={{padding : 10, border:`1px solid #eee`}}>
					<strong>NOTE:</strong> Can&apos;t derive fuel costs because we are missing contract pricing.
					See below or visit the
					<Link to="/inventoryManagement/fuelContracts" style={{textDecoration: 'none'}}> Fuel Contracts Page</Link>
				</div>
			</>}

			<div style={{textAlign:'center', fontWeight: 800}}>FIFO Allocation (net gallons)</div>
			<div style={{
				position : 'relative', width : '100%', height:600,
				display : 'flex',
			}}>
				<div style={{boxSizing: 'border-box', border:'1px solid transparent', width:'33.33%'}}>
					{fifoAllocationSources.map((allocationSource, i) => {
						return this.renderFifo({allocationSource, fuelContractMap, i, len, show: (i % 2)});
					})}
				</div>
				<div style={{ boxSizing: 'border-box', border:'1px solid #444', width:'33.33%' }}>
					{fifoAllocationSources.map((allocationSource, i) => {
						const {allocationPercentage} = allocationSource;
						const style = {
							boxSizing: 'border-box',
							height : `${allocationPercentage * 100}%`,
							backgroundColor: fifoColors[i % fifoColors.length],
							borderBottom : `2px solid ${fifoDarkColors[i % fifoDarkColors.length]}`
						};

						return (<div key={i} style={style}>
						</div>);
					})}
				</div>
				<div style={{boxSizing: 'border-box',  border:'1px solid transparent', width:'33.33%'}}>
					{fifoAllocationSources.map((allocationSource, i) => {
						return this.renderFifo({ allocationSource, i, fuelContractMap, len, show: !(i % 2) });
					})}
				</div>
			</div>
		</div>);
	}

	renderFifo({ allocationSource, fuelContractMap, i, show, len}) {
		const {
			allocationAmount, sortValue, fuelContractId, allocationPercentage,
			finalCostPerGallon, finalBulkCostPerGallon
		} = allocationSource;
		const fuelContract = fuelContractMap[fuelContractId] || {sourceCustomer: 'Missing'};
		const {sourceCustomer, contractNumber} = fuelContract;
		const { classes } = this.props;

		let fontSize = (len >= 4) ? '80%' : '100%';

		const style = {
			boxSizing: 'border-box',
			height : `${allocationPercentage * 100}%`,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-end',
			fontSize,
			lineHeight : 1,
			paddingLeft : 4,
		};
		if (show) {
			style.borderBottom = `2px solid ${fifoDarkColors[i % fifoDarkColors.length]}`;
		}

		return (<div key={`${sortValue}_${show}`} style={style}>
			{!!show && <>
				<div>{sourceCustomer} - {contractNumber}</div>
				<div style={{fontSize : '90%', color:'#666', fontWeight:200}}>
					${finalCostPerGallon}
					{finalBulkCostPerGallon && <span><span className={classes.divider}> | </span>${finalBulkCostPerGallon}</span>}
					<span className={classes.divider}> | </span> {allocationAmount.toLocaleString()} ({_.round(allocationPercentage * 100, 2)}%)
				</div>
			</>}
		</div>);
	}


	drawCostChart = () => {
		const { fuelContractMap } = this.props;
		const { inventoryAllocation } = this.state;

		const COLORS = [
			`rgb(131, 166, 237)`,
			`rgb(141, 209, 225)`,
			`rgb(130, 202, 157)`,
			`rgb(164, 222, 108)`,
			`rgb(208, 237, 87)`,
			`rgb(255,245,157)`,
		];
		const { allocationCosts } = inventoryAllocation;

		const dataForChart = [];
		allocationCosts.forEach(allocationCost => {
			const {fuelCost, allocationAmount, fuelContractId, allocationPercentage, fuelCostPercentage} = allocationCost;
			const fuelContract = fuelContractMap[fuelContractId] || {sourceCustomer: 'Missing'};
			const {sourceCustomer, contractNumber} = fuelContract;
			dataForChart.push({
				name: `${sourceCustomer}`,
				value: allocationPercentage,
				sourceCustomer,
				contractNumber,
				fuelCost,
				allocationAmount,
				allocationPercentage,
				fuelCostPercentage,
			});
		});

		const renderCustomizedPieLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, index }) => {
			const RADIAN = Math.PI / 180;
			const radius = 35 + innerRadius + (outerRadius - innerRadius);
			const x = cx + radius * Math.cos(-midAngle * RADIAN);
			const y = cy + radius * Math.sin(-midAngle * RADIAN);

			const {sourceCustomer, contractNumber, fuelCost,
				allocationAmount, allocationPercentage } = dataForChart[index];
			return (
				<text
					x={x}
					y={y - 10}
					textAnchor={x > cx ? "start" : "end"}
					dominantBaseline="central"
				>
					<tspan x={x + 10} dy="0em" fontSize={'90%'}>{sourceCustomer} - {contractNumber}</tspan>
					<tspan x={x + 10} dy="1em" fontSize={'85%'} fill={'#555555'}>
						${fuelCost} / {allocationAmount.toLocaleString()} ({_.round(allocationPercentage * 100, 2)}%)
					</tspan>
				</text>
			);
		};

		return (
			<ResponsiveContainer width="100%" height='100%'>
				<PieChart>
					<Pie
						isAnimationActive={false}
						data={dataForChart}
						dataKey={'value'}
						cx='50%'
						cy='50%'
						labelLine={true}
						label={renderCustomizedPieLabel}
						outerRadius={'80%'}
						// label={true}
					>
						{
							dataForChart.map((entry, index) =>
								<Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
							)
						}
					</Pie>
				</PieChart>
			</ResponsiveContainer>
		);
	}

	drawProjectionChart = () => {
		const { deliveryInvoiceRows, yearMonth } = this.state;
		if (_.isEmpty(deliveryInvoiceRows)) {
			return (<div>
				Loading...
			</div>);
		}

		const { inventoryAllocation } = this.state;
		const { totalAllocation } = inventoryAllocation;

		//- go through every day of the month and then put the deliveyrInvoicesRows in them.
		//-

		const deliveryInvoiceRowsByDay = _.groupBy(deliveryInvoiceRows, 'deliveryDay');

		const workingMoment = moment(yearMonth, 'YYYY-MM');
		const startOfMonth = moment(workingMoment).startOf('month');
		const endOfMonth = moment(workingMoment).endOf('month');

		const dataForChart = [];
		const indexMoment = moment(startOfMonth);
		let runningTotal = 0;
		while (indexMoment.isBefore(endOfMonth)) {
			const dateKey = indexMoment.format('YYYY-MM-DD');
			const totalForDay = deliveryInvoiceRowsByDay[dateKey] || [];
			runningTotal +=  _.sumBy(totalForDay, 'allocatedGallons');
			dataForChart.push({
				name: indexMoment.format('M/D'),
				totalGallons : runningTotal,
			});
			indexMoment.add(1, 'day');
		}

		_.first(dataForChart).projected100 = 0;
		_.last(dataForChart).projected100 = totalAllocation;

		_.first(dataForChart).projected110 = 0;
		_.last(dataForChart).projected110 = _.round(totalAllocation * 1.1);

		_.first(dataForChart).projected90 = 0;
		_.last(dataForChart).projected90 = _.round(totalAllocation * .9);

		const lineColor = '#666666';
		// const { dataForChart, refLineValue, trendLineProp } = p;
		return (
			<ResponsiveContainer width="100%" height={300}>
				<ComposedChart
					data={dataForChart}
					margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
				>
					<defs>
						<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
							<stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
						</linearGradient>
						<linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
							<stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
						</linearGradient>
					</defs>
					<XAxis dataKey="name" />
					<YAxis />
					<CartesianGrid strokeDasharray="3 3" />
					<Tooltip filterNull={true} />
					<Legend verticalAlign="top" height={36}/>


					<Area
						type="monotone"
						name="Scheduled Deliveries"
						dataKey="totalGallons"
						stroke="#82ca9d"
						fill="url(#colorPv)"
						fillOpacity={1}
					>
					</Area>

					<Line
						name="90% Target"
						dataKey="projected90"
						connectNulls={true}
						stroke={lineColor}
						strokeWidth={1}
						label="90% Target"
						strokeDasharray="3 3"
					/>

					<Line
						name="100% Target"
						dataKey="projected100"
						connectNulls={true}
						stroke={lineColor}
						strokeWidth={2}
						label="100% Target"
					/>

					<Line
						name="110% Target"
						dataKey="projected110"
						connectNulls={true}
						stroke={lineColor}
						strokeWidth={1}
						label="110% Target"
						strokeDasharray="3 3"
					/>

				</ComposedChart>
			</ResponsiveContainer>
		);
	};
}

function addStationDeliveryInvoiceRow(p) {
	const {
		deliveryInvoiceRows,
		stationDelivery,
		stationInvoicesByDeliveryId,
		stationLookup, terminalLookup, //supplierLookup,
		carrierLookup,
		classes,
		allocationProductType,
		deliveryIdToCosts,
	} = p;

	const {
		stationDeliveryId,
		primaryProductType, primaryStationId, primaryDeliveryAmount,
		carrierId,
		deliveryWindowStartDateTime,
	} = stationDelivery;

	//- Format the delivery — one line per stop
	const legs = getDeliveryLegs(stationDelivery);
	const stations = [];
	const primaryStation = stationLookup[primaryStationId] || { number: '?', name: 'Missing'};
	let totalDeliveryAmount = primaryDeliveryAmount;
	let primaryStationDisplay = `${primaryStation.number} - ${primaryStation.name}`;
	if (legs.length > 1) {
		primaryStationDisplay += ` (${primaryDeliveryAmount})`;
	}
	stations.push(primaryStationDisplay);

	legs.filter((leg) => leg.legNumber >= 2).forEach((leg) => {
		const station = stationLookup[leg.stationId] ||{ number: '?', name :'Missing'};
		stations.push(`${station.number} - ${station.name} (${leg.deliveryAmount})`);
		totalDeliveryAmount += leg.deliveryAmount || 0;
	});

	const dateDisplay = moment(deliveryWindowStartDateTime).format('ddd, M/D');
	const deliveryDisplay = (<Fragment>
		<div>
			<a
				href={`/logistics/stationDelivery/update/${stationDeliveryId}`}
				className={classes.linkedItem}
				target="_blank"
				rel='noreferrer noopener'
			>
				<span>Delivery #{stationDeliveryId}</span> <OpenLink className={classes.openLink} />
			</a>

		</div>
		{stations.map((st, i) => {
			return (<div key={i}>{st}</div>);
		})}
		<div>{dateDisplay}</div>
	</Fragment>);

	const carrier = carrierLookup[carrierId] || { name : 'Missing'};
	const primaryProductTypeDisplay = valueToDisplay(primaryProductType);
	const row = {
		key : stationDeliveryId,
		type : 'stationDelivery',
		typeAndProduct : (<div>
			<div>Station Delivery</div>
			<div>{carrier.name}</div>
			<div>{primaryProductTypeDisplay}</div>
		</div>),
		deliveryDateSort : deliveryWindowStartDateTime,
		deliveryDay : moment(deliveryWindowStartDateTime).format('YYYY-MM-DD'),
		productType: primaryProductType,
		primaryProductType,
		deliveryDisplay,
		totalDeliveryAmount,
		carrierDisplay : carrier.name
	};


	const {
		firstTerminalProductType, firstTerminalFuelToPickupTotal,
		secondTerminalProductType, secondTerminalFuelToPickupTotal,
	} = stationDelivery;

	const deliveryVolumes = [{
		productType : firstTerminalProductType, total : firstTerminalFuelToPickupTotal
	}];

	if (secondTerminalProductType && secondTerminalFuelToPickupTotal) {
		deliveryVolumes.push({
			productType: secondTerminalProductType, total: secondTerminalFuelToPickupTotal
		});
	}

	if (allocationProductType === firstTerminalProductType) {
		row.allocatedGallons = firstTerminalFuelToPickupTotal;
	} else if (allocationProductType === secondTerminalProductType) {
		row.allocatedGallons = secondTerminalFuelToPickupTotal;
	}

	const deliveryVolumesByProduct = {};
	row.deliveryVolumes = _.sortBy(deliveryVolumes, 'productType').map(deliveryVolume => {
		const { productType, total} = deliveryVolume;
		deliveryVolumesByProduct[productType] = total;
		return (<div key={productType}>
			<span>{valueToDisplay(productType)} :</span><span>{total}</span>
		</div>);
	});

	//- Match up invoice
	const linkedStationInvoices = stationInvoicesByDeliveryId[stationDeliveryId];
	//- Don't have any invoices yet
	if (_.isEmpty(linkedStationInvoices)) {
		row.invoiceId = null;
		row.invoiceDisplay = 'No invoice yet';
		row.invoiceVolumes = 'No Invoice';
		row.diffDisplay = 'n/a';
		deliveryInvoiceRows.push(row);
		return;
	}

	const invoiceVolumeByType = {};
	const invoiceDisplays = [];
	linkedStationInvoices.forEach(stationInvoice => {
		const { stationInvoiceId, products} = stationInvoice;

		//- InvoiceInfo
		const invoiceLines = [];
		if (_.isEmpty(products)) {
			invoiceLines.push('No fuels yet');
		} else {
			products.forEach(product => {
				const {productType, terminalSupplier, netGallons} = product;
				let terminalDisplay = 'No terminal yet';
				if (terminalSupplier) {
					const terminal = terminalLookup[terminalSupplier.terminalId] ||
						{name: `Missing terminal : ${terminalSupplier.terminalId}`};
					terminalDisplay = terminal.name;
				}
				if (!invoiceVolumeByType[productType]) {
					invoiceVolumeByType[productType] = 0;
				}
				invoiceVolumeByType[productType] += netGallons;
				invoiceLines.push(`${netGallons} ${productType} : ${terminalDisplay}`);
			});
		}

		invoiceDisplays.push((<div key={stationInvoiceId}>
			<div>
				<a
					href={`/accounting/stationInvoice/update/${stationInvoiceId}`}
					className={classes.linkedItem}
					target="_blank"
					rel='noreferrer noopener'
				>
					<span>Invoice #{stationInvoiceId}</span> <OpenLink className={classes.openLink} />
				</a>
			</div>
			<div style={{paddingLeft : 10}}>
				{invoiceLines.map((invoiceLine, i) => {
					return (<div key={`il_${i}`}>{invoiceLine}</div>);
				})}
			</div>
		</div>));
	});

	const diffs = [];
	row.invoiceVolumes = _.keys(invoiceVolumeByType).sort().map(productType => {
		const deliveryTotal = deliveryVolumesByProduct[productType];
		const total = invoiceVolumeByType[productType];
		if (deliveryTotal) {
			const diffTotal = deliveryTotal - total;
			diffs.push({
				productType,
				diffTotal,
				status : (Math.abs(diffTotal) > 200) ? 'diffError' : 'diffNormal'
			});
		}

		return (<div key={productType}>
			<span>{valueToDisplay(productType)} :</span><span>{total}</span>
		</div>);
	});

	row.invoiceDisplay = (<Fragment>
		{invoiceDisplays.map(invoiceDisplay => {
			return invoiceDisplay;
		})}
	</Fragment>);

	let totalDiff = 0;
	row.diffDisplay = diffs.map(diff => {
		const { productType, diffTotal, status} = diff;
		totalDiff += diffTotal;
		return (<div key={productType}>
			<span>{valueToDisplay(productType)} :</span><span className={classes[status]}>{diffTotal}</span>
		</div>);
	});
	row.totalDiff = totalDiff;

	const deliveryCost = deliveryIdToCosts[stationDeliveryId];
	if (deliveryCost) {
		const { finalCostPerGallon} = deliveryCost;
		row.finalCostPerGallon = finalCostPerGallon;
		row.costDisplay = renderDeliveryCost({ deliveryCost });
	}
	deliveryInvoiceRows.push(row);
}

function addBulkDeliveryInvoiceRow(p) {
	const {
		deliveryInvoiceRows,
		bulkDelivery,
		bulkInvoicesByDeliveryId,
		bulkCustomerLookup,
		terminalLookup, carrierLookup,
		// supplierLookup,
		deliveryIdToCosts, classes,
	} = p;

	const {
		bulkDeliveryId,
		deliveryBulkCustomerId,
		productType,
		// deliveryTerminalId,
		// pickupTerminalId,
		// pickupSupplierId,
		deliveryDate,
		carrierId,
	} = bulkDelivery;

	const bulkCustomer = bulkCustomerLookup[deliveryBulkCustomerId] || {name: 'Missing'};
	const bulkCustomerDisplay = bulkCustomer.name;

	//- Delivery
	const dateDisplay = moment(deliveryDate).format('ddd, M/D');
	const deliveryDisplay = (<Fragment>
		<div>
			<a
				href={`/logistics/bulkDelivery/update/${bulkDeliveryId}`}
				className={classes.linkedItem}
				target="_blank"
				rel='noreferrer noopener'
			>
				<span>Delivery #{bulkDeliveryId}</span> <OpenLink className={classes.openLink} />
			</a>
		</div>
		<div>{bulkCustomerDisplay}</div>
		<div>{dateDisplay}</div>
	</Fragment>);

	const totalDeliveryAmount = 8000;
	const carrier = carrierLookup[carrierId] || { name : 'Missing'};
	const productTypeDisplay = valueToDisplay(productType);
	const row = {
		key : bulkDeliveryId,
		type : 'bulkDelivery',
		typeAndProduct : (<div>
			<div>Bulk Delivery</div>
			<div>{carrier.name}</div>
			<div>{productTypeDisplay}</div>
		</div>),
		deliveryDateSort : deliveryDate,
		deliveryDay : moment(deliveryDate).format('YYYY-MM-DD'),
		productType,
		deliveryDisplay,
		totalDeliveryAmount,
		allocatedGallons : totalDeliveryAmount,
		carrierDisplay : carrier.name
	};

	const deliveryVolumes = [{
		productType, total : totalDeliveryAmount
	}];

	const deliveryVolumesByProduct = {};
	row.deliveryVolumes = _.sortBy(deliveryVolumes, 'productType').map(deliveryVolume => {
		const { productType, total} = deliveryVolume;
		deliveryVolumesByProduct[productType] = total;
		return (<div key={productType}>
			<span>{valueToDisplay(productType)} :</span><span>{total}</span>
		</div>);
	});

	//- Match up invoice
	const linkedBulkInvoices = bulkInvoicesByDeliveryId[bulkDeliveryId];
	//- Don't have any invoices yet

	setupBulkInvoiceDisplay({
		row, linkedBulkInvoices, terminalLookup, bulkDelivery,
		carrier, classes, deliveryVolumesByProduct
	});

	const deliveryCost = deliveryIdToCosts[bulkDeliveryId];
	if (deliveryCost) {
		const { finalCostPerGallon} = deliveryCost;
		row.finalCostPerGallon = finalCostPerGallon;
		row.costDisplay = renderDeliveryCost({ deliveryCost });
	}

	deliveryInvoiceRows.push(row);
}

function setupBulkInvoiceDisplay(p) {
	const { row, linkedBulkInvoices, terminalLookup, bulkDelivery, carrier, classes, deliveryVolumesByProduct} = p;

	const {
		deliveryBulkCustomerId,
		productType,
	} = bulkDelivery;

	if (_.isEmpty(linkedBulkInvoices)) {
		if (deliveryBulkCustomerId === RTC_FUELS_BULK_CUSTOMER_ID) {
			row.invoiceId = null;
			row.invoiceDisplay = 'none (RTC Fuels)';
			row.invoiceVolumes = 'none (RTC Fuels)';
			row.diffDisplay = '-';
		} else {
			row.invoiceId = null;
			row.invoiceDisplay = 'No invoice yet';
			row.invoiceVolumes = 'No Invoice';
			row.diffDisplay = 'n/a';
		}
		return;
	}

	const invoiceVolumeByType = {};
	const invoiceDisplays = [];
	linkedBulkInvoices.forEach(bulkInvoice => {
		const {bulkInvoiceId,
			pickupTerminalId, offloadTerminalId,
			pickupNetGallons, offloadNetGallons
		} = bulkInvoice;

		let fuelInfo;
		if (pickupNetGallons && offloadNetGallons) {
			invoiceVolumeByType[productType] = pickupNetGallons;
			const pickupTerminal = terminalLookup[pickupTerminalId] ||  {name: `Missing terminal`};
			const offloadTerminal = terminalLookup[offloadTerminalId] ||  {name: `Missing terminal`};
			fuelInfo = (<Fragment>
				<div>{carrier.name}</div>
				<div>Pickup : {pickupNetGallons} from {pickupTerminal.name}</div>
				<div>Offload : {offloadNetGallons} to {offloadTerminal.name}</div>
			</Fragment>);
		} else {
			fuelInfo = (<Fragment>
				<div>No documents yet</div>
			</Fragment>);
		}

		invoiceDisplays.push((<div key={bulkInvoiceId}>
			<div>
				<a
					href={`/accounting/bulkInvoice/update/${bulkInvoiceId}`}
					className={classes.linkedItem}
					target="_blank"
					rel='noreferrer noopener'
				>
					<span>Invoice #{bulkInvoiceId}</span> <OpenLink className={classes.openLink} />
				</a>
			</div>
			<div style={{paddingLeft : 10}}>
				{fuelInfo}
			</div>
		</div>));
	});

	row.invoiceDisplay = (<Fragment>
		{invoiceDisplays.map(invoiceDisplay => {
			return invoiceDisplay;
		})}
	</Fragment>);

	if (_.isEmpty(_.keys(invoiceVolumeByType))) {
		row.invoiceVolumes = 'n/a';
		row.diffDisplay = 'n/a';
		return;
	}

	const diffs = [];
	row.invoiceVolumes = _.keys(invoiceVolumeByType).sort().map(productType => {
		const deliveryTotal = deliveryVolumesByProduct[productType];
		const total = invoiceVolumeByType[productType];
		if (deliveryTotal) {
			const diffTotal = deliveryTotal - total;
			diffs.push({
				productType,
				diffTotal,
				status : (Math.abs(diffTotal) > 300) ? 'diffError' : 'diffNormal'
			});
		}

		return (<div key={productType}>
			<span>{valueToDisplay(productType)} :</span><span>{total}</span>
		</div>);
	});

	let totalDiff = 0;
	row.diffDisplay = diffs.map(diff => {
		const { productType, diffTotal, status} = diff;
		totalDiff += diffTotal;
		return (<div key={productType}>
			<span>{valueToDisplay(productType)} :</span><span className={classes[status]}>{diffTotal}</span>
		</div>);
	});
	row.totalDiff = totalDiff;
}


function renderDeliveryCost(p) {
	const {deliveryCost} = p;
	const { finalCostPerGallon, costs} = deliveryCost;
	const style = {
		display : 'inline-block',
		marginRight : 4,
		width : 10,
		height : 10,
	};

	if (!finalCostPerGallon) {
		return (<div>n/a</div>);
	}

	if (!costs) {
		const {fifoIndex} = deliveryCost;
		style.backgroundColor = `${fifoDarkColors[fifoIndex % fifoDarkColors.length]}`;
		return (<div>
			<div style={style}/>
			{formatCpg(finalCostPerGallon)}
		</div>);
	}

	// When it has a cos transition
	if (costs.length < 2) {
		return (<div>Problem: ONly one cost</div>);
	}

	/** @namespace cost.fifoIndex **/
	const firstColor = fifoDarkColors[costs[0].fifoIndex % fifoDarkColors.length];
	const secondColor = fifoDarkColors[costs[1].fifoIndex % fifoDarkColors.length];

	style.background = `linear-gradient(to right, ${firstColor} 50%, ${secondColor} 50%)`;
	return (<div>
		<div>
			<div style={style} />
			{formatCpg(finalCostPerGallon)}
		</div>

		{costs.map((cost, i) => {
			const { fifoIndex, netGallons, costPerGallon } = cost;

			const subStyle = {
				display : 'inline-block',
				backgroundColor : `${fifoDarkColors[fifoIndex % fifoDarkColors.length]}`,
				marginRight : 4,
				width : 8,
				height : 8,
				marginLeft : 5,
			};

			return (<div key={i}>
				<div style={subStyle} />
				<span style={{fontSize:'90%', color:'#444', fontWeight:200}}>
					{netGallons.toLocaleString()} x {formatCpg(costPerGallon)}
				</span>
			</div>);
		})}
	</div>);
}


InventoryAllocationDetails.propTypes = {
	classes: PropTypes.object.isRequired,
	inventoryAllocationSearch : PropTypes.func.isRequired,
	inventoryAllocationsByYearMonth : PropTypes.object,
	showErrors : PropTypes.func.isRequired,

	history : PropTypes.object,
	theme: PropTypes.object.isRequired,

	fuelContractMap : PropTypes.object,
	supplierMap : PropTypes.object,
	terminalMap : PropTypes.object,
	additionalFuelAllocationMap : PropTypes.object,
	fuelMaintenanceCostMap : PropTypes.object,
	userMap : PropTypes.object,

	canRwInventoryAllocation : PropTypes.bool,
};

export default _.flow([
	InventoryAllocationsContainer,
	withStyles(styles, { withTheme: true }),
])(InventoryAllocationDetails);
